const pdpReviewsObserver = () => {
  const parent = document.querySelector("[data-hulkapps-reviews-list]");

  // Options for the observer (which mutations to observe)
  const config = { attributes: false, childList: true, subtree: true };
  
  // Callback function to execute when mutations are observed
  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.addedNodes[0].className === "hulk_reviews-summary") {
        const starContainer = document.querySelector("#pdp-stars");
        const totalReviews = document.querySelector("#total-reviews");

        const totalReviewsElement = document.querySelector(".hulk__overall-rating.hulk-text-center p");
        const totalRateElement = document.querySelector(".hulk__overall-rating.hulk-text-center span.h2");

        if (totalReviewsElement != null) {
          const re = /\d+/;
          const total = totalReviewsElement.textContent.match(re);

          if (total) {
            totalReviews.textContent = total[0];

            if (total[0] == 1) {
              document.querySelector("#califications").textContent = "Calificación"
            }
          }
        }

        if (totalRateElement != null) {
          const totalRate = totalRateElement.textContent;
          const pdpstars = starContainer.querySelectorAll(".icon-review.ion-ios-star")

          switch (true) {
            case totalRate > 4:
              pdpstars.forEach(start => {
                start.classList.add("icon-fill");
              });
              break;
            case totalRate > 3:
              pdpstars[0].classList.add("icon-fill");
              pdpstars[1].classList.add("icon-fill");
              pdpstars[2].classList.add("icon-fill");
              pdpstars[3].classList.add("icon-fill");
              break;
            case totalRate > 2:
              pdpstars[0].classList.add("icon-fill");
              pdpstars[1].classList.add("icon-fill");
              pdpstars[2].classList.add("icon-fill");
              break;
            case totalRate > 1:
              pdpstars[0].classList.add("icon-fill");
              pdpstars[1].classList.add("icon-fill");
              break;
            default:
              pdpstars[1].classList.add("icon-fill");
              break;
          }          
        }

        totalReviews.parentNode.classList.remove("d-none");
      }
    }
  };
  
  const observer = new MutationObserver(callback);
  
  observer.observe(parent, config);
}

pdpReviewsObserver()